import React from "react";
import { Heart } from "lucide-react";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="mx-auto flex w-full max-w-content items-center justify-center gap-1.5 px-5 pb-28 pt-8 text-sm text-neutral-500">
      <span>&copy; {year} Designed with</span>
      <Heart size={14} className="text-neutral-600 dark:text-neutral-400" aria-label="love" />
      <span>by Faiz Shaikh.</span>
    </footer>
  );
}
